<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile()"
    max-width="750"
    scrollable
  >
    <v-card>
      <toolbar-card-visita
        :opcao_checklist="
          configuracoes.dados.opcoes_checklist.find(
            (oc) => oc.rota == '/locomocao'
          )
        "
      />
      <v-card-text class="pt-5">
        <slider-imagens-visita categoria="locomocao" />

        <v-row class="mt-4">
          <v-col cols="12">
            <v-textarea
              rows="5"
              outlined
              label="Observações cascos"
              placeholder="Ex.: rachaduras, feridas, calor, dor, inchaços ou outras alterações nos cascos."
              persistent-placeholder
              v-model="visita.obs_cascos"
              auto-grow
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import SliderImagensVisita from "./SliderImagensVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
export default {
  components: { ToolbarCardVisita, SliderImagensVisita, BtnSalvarDadosVisita },
  computed: mapState("visitaTecnica", ["configuracoes", "visita"]),
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  data: () => ({
    dialog: false,    
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>